export default{
    namespaced: true,

    state:{
        tiposIncidencias:[],
        areasEnfermeria:[],
        estadoCivilItems:[
            {value:1, text:"Sotero"},
            {value:2, text:"Casado"},
            {value:3, text:"Viudo"},
            {value:4, text:"Divorciado"},
            {value:5, text:"Union Libre"},
            {value:90, text:"Otro"},
            {value:99, text:"Se desconoce"},
        ],
        estadoCivil:{
            1:"Sotero",
            2:"Casado",
            3:"Viudo",
            4:"Divorciado",
            5:"Union Libre",
            90:"Otro",
            99:"Se desconoce",
        },


        tipoSangre:[
            {value: 'O+',text: 'O+'},
            {value: 'A+',text: 'A+'},
            {value: 'B+',text: 'B+'},
            {value: 'O-',text: 'O-'},
            {value: 'A-',text: 'A-'},
            {value: 'AB+',text: 'AB+'},
            {value: 'B-',text: 'B-'},
            {value: 'AB-',text: 'AB-'},
        ],
        camas:[
            {id: 1, cama: 'Cama 1'},
            {id: 2, cama: 'Cama 2'},
            {id: 3, cama: 'Cama 3'},
            {id: 4, cama: 'Cama 4'},
            {id: 5, cama: 'Cama 5'},
            {id: 6, cama: 'Cama 6'},
            {id: 99, cama: 'SIN CAMA'}
        ],
        tipoEgreso:[
            {id: 1, tipoAlta: 'Mejoría'},
            {id: 2, tipoAlta: 'Voluntaria'},
            {id: 3, tipoAlta: 'Emergencia'},
            {id: 4, tipoAlta: 'Fallecimiento'},
            {id: 5, tipoAlta: 'Procedimiento Cancelado'},
            {id: 6, tipoAlta: 'Traslado/Referencia'},
            {id: 7, tipoAlta: 'Curación'},
            {id: 8, tipoAlta: 'Fuga'},
            {id: 9, tipoAlta: 'Otro motivo'}
        ],

        coloresCirugia:{
            1:'blue', // Solicitado
            2:'green',
            3:'light-blue',
            4:'grey',
            5:'orange', // En sala
            6:'green', // Realizado
            98:'deep-purple darken-4', // Diferida
            99:'red', // Cancelado
        },
        coloresTipoCita:{
            1:'orange',
            2:'green',
            3:'light-blue',
            4:'grey',
            5:'red',
            6:'red',
            90:'red',
            99:'purple'
        },

        tiempoRecu:{
            0:'No requiere',
            1:'1-6 hrs',
            2:'7-12 hrs',
            3:'13-24 hrs',
            4:'> 24 Hrs',
        },
        tiempoRecuItems:[
            {value:0, text:'No requiere'},
            {value:1, text:'1-6 hrs'},
            {value:2, text:'7-12 hrs'},
            {value:3, text:'13-24 hrs'},
            {value:4, text:'> 24 Hrs'}
        ],
        statusRx:[
            {value:1, text:'Solcitado', color:'purple'},
            {value:2, text:'Realizado', color:'green'},
            {value:3, text:'Agendado', color:'orange'},
            {value:4, text:'Cancelado', color:'red'},
        ],

        catalogoGrupEstudioImagen:[
            {value:1, text:'Otros'},
            {value:11, text:'US General'},
            {value:12, text:'US Doopler'},
            {value:13, text:'US Intervención'},
            {value:14, text:'US Second look'},
            {value:15, text:'RX Gabinete'},
            {value:16, text:'RX Portatil'},
            {value:17, text:'EC Endoscopias'},
        ],
        catalogoGrupEstudioLab:[
            {value:10, text:'PATOLOGÍA'},
            {value:20, text:'LABORATORIO'},
            {value:30, text:'PAQUETES'},
            {value:1, text:'OTROS'},
        ],

        ocupacionEspecifica:[
            {value: "1.1", text: "Agricultura y silvicultura"},
            {value: "1.2", text: "Ganadería"},
            {value: "1.3", text: "Pesca y acuacultura"},
            {value: "2.1", text: "Exploración"},
            {value: "2.2", text: "Extracción"},
            {value: "2.3", text: "Refinación y beneficio"},
            {value: "2.4", text: "Provisión de energía"},
            {value: "2.5", text: "Provisión de agua"},
            {value: "3.1", text: "Planeación y dirección de obras"},
            {value: "3.2", text: "Edificación y urbanización"},
            {value: "3.3", text: "Acabado (construcción)"},
            {value: "3.4", text: "Instalación y mantenimiento (construcción)"},
            {value: "4.1", text: "Mecánica"},
            {value: "4.2", text: "Electricidad"},
            {value: "4.3", text: "Electrónica"},
            {value: "4.4", text: "Informática"},
            {value: "4.5", text: "Telecomunicaciones"},
            {value: "4.6", text: "Procesos industriales"},
            {value: "5.1", text: "Minerales no metálicos"},
            {value: "5.2", text: "Metales (procesamiento)"},
            {value: "5.3", text: "Alimentos y bebidas"},
            {value: "5.4", text: "Textiles y prendas de vestir"},
            {value: "5.5", text: "Materia orgánica (procesamiento)"},
            {value: "5.6", text: "Productos químicos (procesamiento)"},
            {value: "5.7", text: "Productos metálicos y de hule y plástico (procesamiento)"},
            {value: "5.8", text: "Productos eléctricos y electrónicos ()procesamiento"},
            {value: "5.9", text: "Productos impresos (procesamiento)"},
            {value: "6.1", text: "Ferroviario (transportes)"},
            {value: "6.2", text: "Autotransporte (transportes)"},
            {value: "6.3", text: "Aéreo (transportes)"},
            {value: "6.4", text: "Marítimo y fluvial (transportes)"},
            {value: "6.5", text: "Servicios de apoyo (transportes)"},
            {value: "7.1", text: "Comercio"},
            {value: "7.2", text: "Alimentación y hospedaje"},
            {value: "7.3", text: "Turismo"},
            {value: "7.4", text: "Deporte y esparcimiento"},
            {value: "7.5", text: "Servicios personales"},
            {value: "7.6", text: "Reparación de artículos de uso doméstico y personal"},
            {value: "7.7", text: "Limpieza"},
            {value: "7.8", text: "Servicio postal y mensajería"},
            {value: "8.1", text: "Bolsa, banca y seguros"},
            {value: "8.2", text: "Administración"},
            {value: "8.3", text: "Servicios legales"},
            {value: "9.1", text: "Servicios médicos"},
            {value: "9.2", text: "Inspección sanitaria y del medio ambiente"},
            {value: "9.3", text: "Seguridad social"},
            {value: "9.4", text: "Protección de bienes y/o personas"},
            {value: "10.1", text: "Publicación"},
            {value: "10.2", text: "Radio, cine, televisión y teatro"},
            {value: "10.3", text: "Interpretación artística"},
            {value: "10.4", text: "Traducción e interpretación lingüística"},
            {value: "10.5", text: "Publicidad, propaganda y relaciones públicas"},
            {value: "11.1", text: "Investigación"},
            {value: "11.2", text: "Enseñanza"},
            {value: "11.3", text: "Difusión cultural"},
        ],

        areasTematicas:[
            {value:"1000", text: "Producción general"},
            {value:"2000", text: "Servicios"},
            {value:"3000", text: "Administración, contabilidad y economía"},
            {value:"4000", text: "Comercialización"},
            {value:"5000", text: "Mantenimiento y reparación"},
            {value:"6000", text: "Seguridad"},
            {value:"7000", text: "Desarrollo personal y familiar"},
            {value:"8000", text: "Uso de tecnologías de la información y comunicación"},
            {value:"9000", text: "Participación Social"},

        ],

        localidades:[],
        localidadesLoading:false,

        categoriasConsumo:[
            {value:1, text:'Consumibles médicos'},
            {value:2, text:'Esterilización'},
            {value:3, text:'Estudios'},
            {value:4, text:'Instrumental médico'},
            {value:5, text:'Material de curación'},
            {value:6, text:'Oftalmología'},
            {value:7, text:'Medicamento GENERAL'},
            {value:8, text:'Medicamento GPO I'},
            {value:9, text:'Medicamento GPO II'},
            {value:10, text:'Mobiliario'},
            {value:11, text:'Activo fijo'},
            {value:12, text:'Servicio'},
            {value:999, text:'OTROS'},

        ],

    },
    mutations:{
    },
    actions:{
        async tiposIncidencias(context){
            let datos = []
            try{
                const req = await this.$http({
                    url:context.rootState.http.catalogos.incidencias,
                    method:'GET',
                })
                context.state.tiposIncidencias = req.data
            }catch(err){
                datos.estado = false
                datos.error = err
            }
            return datos
        },
        async catalogoAreasEnfermeria(context){
            let datos = []
            try{
                const req = await this.$http({
                    url:context.rootState.http.catalogos.catalogoAreasEnfermeria,
                    method:'GET',
                })
                context.state.areasEnfermeria = req.data
            }catch(err){
                datos.estado = false
                datos.error = err
            }
            return datos
        },
        async cargaLocalidades(context){
            try{
                context.state.localidadesLoading = true
                let loc = await this.$http({
                    method:'GET',
                    url:'/catalogos/estados'
                })
                context.state.localidadesLoading = false
                context.state.localidades = loc.data
                //console.log(loc.data)
            }catch(err){
                context.state.localidadesLoading = false
                this.$store.dispatch('security/revisaError',err)

            }
        },

    },
    getters:{
        getColorCalificacion: () => (id) => {
            let color = 'black'

            if (id >=90){
                color = 'green'
            }

            if (id >=60 && id < 90){
                color = 'orange'
            }

            if (id < 60){
                color = 'red'
            }
            //return state.todos.find(todo => todo.id === id)
            return color
          }
    },
}